import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const StaffPortal = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Simulate logout logic
    navigate('/staff-login');
  };

  return (
    <div className="portal-layout" style={{ backgroundColor: '#f4f6f8', minHeight: '100vh', paddingBottom: '6rem' }}>
      
      {/* INJECTED STYLE TO HIDE THE GLOBAL PUBLIC HEADER & FOOTER */}
      <style>
        {`
          .site-header, .site-footer {
            display: none !important;
          }
        `}
      </style>

      {/* PORTAL SPECIFIC HEADER */}
      <header 
        className="portal-header" 
        style={{ 
          position: 'fixed', 
          top: 0, left: 0, width: '100%', 
          backgroundColor: 'var(--color-primary-navy)', 
          zIndex: 1100, 
          padding: '1rem 2rem', 
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ width: '10px', height: '10px', backgroundColor: '#27ae60', borderRadius: '50%', boxShadow: '0 0 10px #27ae60' }}></div>
          <div style={{ fontWeight: '800', letterSpacing: '2px', color: 'var(--color-white)', fontSize: '1.2rem' }}>
            NIGHTMARK <span style={{ color: 'var(--color-secondary-grey)', fontWeight: '400' }}>| NOC DASHBOARD</span>
          </div>
        </div>
        <div className="portal-user-actions" style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <span style={{ color: 'var(--color-secondary-light)', fontWeight: '600', fontSize: '0.9rem', letterSpacing: '1px' }}>
            OPERATIVE: <span style={{ color: 'var(--color-white)' }}>E. JOHNSON (NMK-10294)</span>
          </span>
          <button 
            onClick={handleLogout} 
            style={{ 
              backgroundColor: 'rgba(255,255,255,0.1)', 
              color: 'var(--color-white)', 
              border: '1px solid rgba(255,255,255,0.2)', 
              padding: '0.5rem 1.5rem', 
              borderRadius: '4px', 
              fontWeight: '700', 
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={e => { e.target.style.backgroundColor = 'var(--color-white)'; e.target.style.color = 'var(--color-primary-navy)'; }}
            onMouseOut={e => { e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'; e.target.style.color = 'var(--color-white)'; }}
          >
            SECURE LOGOUT
          </button>
        </div>
      </header>

      {/* PORTAL MAIN CONTENT */}
      <main className="portal-main container" style={{ paddingTop: '120px', maxWidth: '1400px' }}>
        
        {/* Status Bar */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '2.5rem', borderBottom: '2px solid rgba(0,0,0,0.05)', paddingBottom: '1rem' }}>
          <div>
            <h1 style={{ color: 'var(--color-primary-navy)', fontSize: '2.2rem', marginBottom: '0.25rem' }}>Welcome, Emanuel.</h1>
            <p style={{ margin: 0, color: 'var(--color-secondary-grey)', fontWeight: '500' }}>Last Login: 09 Mar 2026 • 08:14 GMT (IP: 192.168.1.1)</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '0.25rem' }}>Current UK Threat Level</span>
            <span style={{ display: 'inline-block', backgroundColor: '#e67e22', color: 'white', padding: '0.4rem 1rem', borderRadius: '4px', fontWeight: '800', letterSpacing: '2px', fontSize: '1rem' }}>SUBSTANTIAL</span>
          </div>
        </div>

        {/* Dashboard Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2rem' }}>
          
          {/* PANEL 1: Upcoming Deployment Brief */}
          <div className="portal-card" style={{ backgroundColor: 'var(--color-white)', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ backgroundColor: 'var(--color-primary-navy)', padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ color: 'var(--color-white)', margin: 0, fontSize: '1.1rem', letterSpacing: '1px' }}>Active Deployment Brief</h3>
              <span style={{ backgroundColor: '#27ae60', color: 'white', padding: '0.25rem 0.75rem', borderRadius: '50px', fontSize: '0.75rem', fontWeight: '700' }}>ON SCHEDULE</span>
            </div>
            <div style={{ padding: '2rem 1.5rem' }}>
              <div style={{ marginBottom: '1.5rem' }}>
                <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Location / Client</span>
                <strong style={{ fontSize: '1.2rem', color: 'var(--color-primary-dark)' }}>Canary Wharf Tower (Alpha Floor)</strong>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                <div>
                  <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase' }}>Shift Time</span>
                  <strong style={{ color: 'var(--color-primary-navy)' }}>19:00 - 07:00</strong>
                </div>
                <div>
                  <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase' }}>Date</span>
                  <strong style={{ color: 'var(--color-primary-navy)' }}>16 Mar 2026</strong>
                </div>
                <div>
                  <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase' }}>Duty Type</span>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Static Guarding & Access</strong>
                </div>
                <div>
                  <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-secondary-grey)', fontWeight: '700', textTransform: 'uppercase' }}>Dress Code</span>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Corporate Suit (Tie)</strong>
                </div>
              </div>
              <div style={{ backgroundColor: 'var(--color-secondary-light)', padding: '1rem', borderRadius: '8px', borderLeft: '4px solid var(--color-primary-navy)' }}>
                <span style={{ display: 'block', fontSize: '0.85rem', color: 'var(--color-primary-dark)', fontWeight: '700', textTransform: 'uppercase', marginBottom: '0.25rem' }}>Supervisor Notes</span>
                <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--color-secondary-grey)' }}>VIP Board meeting taking place on Alpha Floor at 20:00. Maintain high visibility in the main lobby until 21:30.</p>
              </div>
              <button style={{ width: '100%', marginTop: '1.5rem', backgroundColor: 'var(--color-primary-navy)', color: 'white', border: 'none', padding: '1rem', borderRadius: '8px', fontWeight: '700', cursor: 'pointer' }}>
                CONFIRM BRIEFING READ
              </button>
            </div>
          </div>

          {/* PANEL 2: Live NOC Directives & Intelligence */}
          <div className="portal-card" style={{ backgroundColor: 'var(--color-white)', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ color: 'var(--color-primary-navy)', margin: 0, fontSize: '1.1rem', letterSpacing: '1px' }}>Live Threat Intelligence</h3>
              <span style={{ color: '#e74c3c', fontSize: '0.8rem', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span style={{ width: '8px', height: '8px', backgroundColor: '#e74c3c', borderRadius: '50%', display: 'inline-block' }}></span> LIVE
              </span>
            </div>
            <div style={{ padding: '1.5rem' }}>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                <li style={{ paddingBottom: '1.5rem', borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <span style={{ backgroundColor: '#fdf2e9', color: '#e67e22', padding: '0.2rem 0.5rem', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '800' }}>WARNING</span>
                    <div>
                      <strong style={{ color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.25rem', fontSize: '0.95rem' }}>Protest Activity - Central London</strong>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-secondary-grey)' }}>Large crowds expected near Westminster from 14:00. Mobile units to avoid restricted zones and maintain lock-doors protocol.</p>
                      <span style={{ fontSize: '0.75rem', color: '#bdc3c7', marginTop: '0.5rem', display: 'block' }}>Posted: 09 Mar • 06:30</span>
                    </div>
                  </div>
                </li>
                <li style={{ paddingBottom: '1.5rem', borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <span style={{ backgroundColor: '#e8f6f3', color: '#d35400', padding: '0.2rem 0.5rem', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '800' }}>ADVISORY</span>
                    <div>
                      <strong style={{ color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.25rem', fontSize: '0.95rem' }}>Weather Protocol Alpha</strong>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-secondary-grey)' }}>Heavy rain and localized flooding expected tonight. High-Vis foul weather gear is authorized for all exterior patrols.</p>
                      <span style={{ fontSize: '0.75rem', color: '#bdc3c7', marginTop: '0.5rem', display: 'block' }}>Posted: 08 Mar • 18:45</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <span style={{ backgroundColor: '#ebf5fb', color: '#16a085', padding: '0.2rem 0.5rem', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '800' }}>UPDATE</span>
                    <div>
                      <strong style={{ color: 'var(--color-primary-dark)', display: 'block', marginBottom: '0.25rem', fontSize: '0.95rem' }}>New Radio Frequencies</strong>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-secondary-grey)' }}>Channel 4 is now designated strictly for emergency escalations. Routine comms to remain on Channel 1.</p>
                      <span style={{ fontSize: '0.75rem', color: '#bdc3c7', marginTop: '0.5rem', display: 'block' }}>Posted: 07 Mar • 09:00</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* PANEL 3: Compliance & Equipment Log */}
          <div className="portal-card" style={{ backgroundColor: 'var(--color-white)', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', padding: '1.25rem 1.5rem' }}>
              <h3 style={{ color: 'var(--color-primary-navy)', margin: 0, fontSize: '1.1rem', letterSpacing: '1px' }}>Operative Compliance & Assets</h3>
            </div>
            <div style={{ padding: '1.5rem' }}>
              
              <h4 style={{ fontSize: '0.85rem', textTransform: 'uppercase', color: 'var(--color-secondary-grey)', letterSpacing: '1px', marginBottom: '1rem' }}>Licensing & Vetting</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2rem 0', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>SIA License (CP)</strong>
                  <span style={{ color: '#27ae60', fontWeight: '700' }}>Valid (Exp: Oct 2028)</span>
                </li>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>First Aid (FREC 3)</strong>
                  <span style={{ color: '#27ae60', fontWeight: '700' }}>Valid (Exp: Jan 2027)</span>
                </li>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>BS7858 Vetting</strong>
                  <span style={{ color: '#27ae60', fontWeight: '700' }}>Cleared</span>
                </li>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Fire Safety Mod. 2</strong>
                  <span style={{ color: '#e74c3c', fontWeight: '700' }}>Due Renewal (14 Days)</span>
                </li>
              </ul>

              <h4 style={{ fontSize: '0.85rem', textTransform: 'uppercase', color: 'var(--color-secondary-grey)', letterSpacing: '1px', marginBottom: '1rem' }}>Assigned Assets</h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Motorola Radio</strong>
                  <span style={{ color: 'var(--color-secondary-grey)' }}>ID: RAD-092</span>
                </li>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Body Worn Camera</strong>
                  <span style={{ color: 'var(--color-secondary-grey)' }}>ID: BWC-414</span>
                </li>
                <li style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.95rem' }}>
                  <strong style={{ color: 'var(--color-primary-dark)' }}>Defibrillator Kit</strong>
                  <span style={{ color: 'var(--color-secondary-grey)' }}>ID: MED-011</span>
                </li>
              </ul>
            </div>
          </div>

          {/* PANEL 4: Quick Actions & Forms */}
          <div className="portal-card" style={{ backgroundColor: 'var(--color-white)', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', padding: '1.25rem 1.5rem' }}>
              <h3 style={{ color: 'var(--color-primary-navy)', margin: 0, fontSize: '1.1rem', letterSpacing: '1px' }}>Operational Forms & Actions</h3>
            </div>
            <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              
              <button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '1.25rem', backgroundColor: '#f8f9fa', border: '1px solid rgba(0,0,0,0.05)', borderRadius: '8px', cursor: 'pointer', transition: 'background 0.3s ease' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#eef0f2'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                <span style={{ fontWeight: '700', color: 'var(--color-primary-dark)' }}>Log On-Duty (Book On)</span>
                <span style={{ color: 'var(--color-primary-navy)' }}>→</span>
              </button>

              <button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '1.25rem', backgroundColor: '#f8f9fa', border: '1px solid rgba(0,0,0,0.05)', borderRadius: '8px', cursor: 'pointer', transition: 'background 0.3s ease' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#eef0f2'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                <span style={{ fontWeight: '700', color: '#e74c3c' }}>Submit Incident Report (DIR)</span>
                <span style={{ color: 'var(--color-primary-navy)' }}>→</span>
              </button>

              <button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '1.25rem', backgroundColor: '#f8f9fa', border: '1px solid rgba(0,0,0,0.05)', borderRadius: '8px', cursor: 'pointer', transition: 'background 0.3s ease' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#eef0f2'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                <span style={{ fontWeight: '700', color: 'var(--color-primary-dark)' }}>Request Leave / Absence</span>
                <span style={{ color: 'var(--color-primary-navy)' }}>→</span>
              </button>

              <button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '1.25rem', backgroundColor: '#f8f9fa', border: '1px solid rgba(0,0,0,0.05)', borderRadius: '8px', cursor: 'pointer', transition: 'background 0.3s ease' }} onMouseOver={e => e.currentTarget.style.backgroundColor = '#eef0f2'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#f8f9fa'}>
                <span style={{ fontWeight: '700', color: 'var(--color-primary-dark)' }}>View Timesheets & Payroll</span>
                <span style={{ color: 'var(--color-primary-navy)' }}>→</span>
              </button>

            </div>
          </div>

        </div>
      </main>

    </div>
  );
};

export default StaffPortal;